import {
  Filter,
  OrderByType,
  useGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import { useAuth } from "../../auth/hooks";
import { BASE_URL_STATION, BASE_URL_STATION_CLIENT } from "../services/stationsAPI";
import { Station, StationPatch } from "../types/stations.types";

/**
 * useStation
 * @param config
 * @returns
 */
export default function useStation(config?: {
  pageSize?: number;
  organizationId?: string;
  orderBy?: OrderByType<Station>;
  directfilter?: Filter<Station>;
}) {
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();
  const { getAllQuery, createNew } = useGenericAPI<
    Station,
    StationPatch,
    StationPatch
  >({
    baseURL: BASE_URL_STATION,
    APIname: "stations",
    pageSize: config?.pageSize,
    orderBy: config?.orderBy || "-station_created_at",
    preFilter: config?.organizationId
      ? {
          station_organization_id: config?.organizationId
            ? `='${config?.organizationId}'`
            : undefined,
        }
      : undefined,
    directFilter: config?.directfilter,
  });

  return {
    getAllStationQuery: getAllQuery,
    createNewStationQuery: createNew,
  };
}

export const useStationClient = (config?:{
  pageSize?: number;
  orderBy?: OrderByType<Station>;
  directfilter?: Filter<Station>;
}) => {

  const { getAllQuery } = useGenericAPI<
  Station,
  StationPatch,
  StationPatch
>({
  baseURL: BASE_URL_STATION_CLIENT,
  APIname: "stations-client",
  pageSize: config?.pageSize,
  orderBy: config?.orderBy || "-station_created_at",
  directFilter: config?.directfilter,
});

return {
  getAllStationQuery: getAllQuery,

};
}
